import PropTypes from 'prop-types';

const GalleryOptionsPropType = {
  classes: PropTypes.instanceOf(Object).isRequired,
  onImagePick: PropTypes.func,
};

export default GalleryOptionsPropType;
